import axios from 'axios';
import config from '../config';
import { showError } from '../utils';
import { logEvent } from '../utils/logEvent';
import LogRocket from 'logrocket';

export function fetchProviders(authToken) {
  return axios.get(config.apiBaseUrl + '/opd/organization/fetch', {
    headers: {
      Authorization: authToken,
      'Content-Type': 'application/json',
    },
  });
}

export function changeProvider(authToken, id) {
  return axios.post(
    config.apiBaseUrl + '/opd/organization/select',
    {
      dopeEntityId: id,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
}

export function linkBenefit(authToken, email, isSignUp) {
  return axios.post(
    config.apiBaseUrl + '/new-auth/v2/verify-b2b',
    {
      email,
      isSignUp,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
}

export function verifyOtp(authToken, email, verificationCode) {
  return axios.post(
    config.apiBaseUrl + '/new-auth/link-b2b/verify-otp',
    {
      email,
      verificationCode,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
}
